import React from 'react';

const HourlyTableComponent = ({ csvData }) => {
  if (!csvData?.length) {
    return <div className="gen-hourly-empty">표시할 데이터가 없습니다.</div>;
  }

  return (
    <div className="hourly-table-container">
      <table className="styled-table hourly-table">
        <thead>
          <tr>
            <th>시간</th>
            <th>인버터</th>
            <th>인버터출력 (kW)</th>
            <th>누적발전량 (kWh)</th>
            <th>측정시각</th>
          </tr>
        </thead>
        <tbody>
          {csvData.map((row, index) => (
            <tr key={`${row.Time}-${row.Inverter}-${index}`}>
              <td>{row.Time}</td>
              <td>{row.Inverter}</td>
              <td>{row.GridPower}</td>
              <td>{row.AddPowerKwh}</td>
              <td>{row.created_at}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HourlyTableComponent;
